import { useCallback, MouseEvent } from 'react';
import { useHistory } from 'react-router-dom';
import useHistoryActions from 'data/hooks/useHistoryActions';

const useConnect = (orderId: string) => {
  const { location, push } = useHistory();
  const { printOrder } = useHistoryActions();

  const goToOrder = useCallback(() => {
    const newLocation = {
      pathname: `/orders/${orderId}`,
      state: { prevPathname: location.pathname },
    };

    push(newLocation);
  }, [location, push, orderId]);

  const handlePrintOrder = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      event.stopPropagation();
      printOrder({ orderId });
    },
    [printOrder, orderId],
  );

  return {
    goToOrder,
    handlePrintOrder,
  };
};

export default useConnect;
